<template>
  <v-row>
    <v-col cols="12">
      <v-card outlined class="rounded-card">
        <v-subheader class="grey lighten-2 text--primary font-weight-bold">
          Mensagens personalizadas
        </v-subheader>
        <v-divider/>
        <px-mensagens-personalizadas-list :messages="aprovacao.mensagensPersonalizadas"/>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
  },
};
</script>
